import { CREATE_EVENT } from "../actions/eventAction";

const default_event_info = {
    name: '',
    description: '',
    image: '',
    location: '',
    date: '',
    hour: '',
    eventType: '',
    eventPrivacity: '',
    guests: '',
    eventCaracteristics: '',
    creator: '',

}


const eventReducer = (state = default_event_info, action) => {
    switch (action.type) {
        case CREATE_EVENT: {
            return {
                ...state,
                name: action.info[0],
                description: action.info[1],
                creator: action.info[2],
                eventType: action.info[3],
                date: action.info[4],
                hour: action.info[5]
            }
        }
    
        default: return state;
    }
}

export default eventReducer